var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLivesessionTypeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgexport-6_37_",
    "data-name": "svgexport-6 (37)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.943,
    height: 28.943,
    viewBox: "0 0 28.943 28.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10292",
    "data-name": "Group 10292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10291",
    "data-name": "Group 10291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10611",
    "data-name": "Path 10611",
    d: "M14.472,0A14.472,14.472,0,1,0,28.943,14.472,14.472,14.472,0,0,0,14.472,0Zm6.095,14.933a1.034,1.034,0,0,1-.464.464V15.4l-8.269,4.135a1.034,1.034,0,0,1-1.5-.93V10.337a1.034,1.034,0,0,1,1.5-.925L20.1,13.546A1.034,1.034,0,0,1,20.566,14.933Z",
    transform: "translate(0)",
    fill: "#7e59d1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivesessionTypeIcon);
export default __webpack_public_path__ + "static/media/livesession-type-icon.00614aae37daed7777bd1c6c7ee7278f.svg";
export { ForwardRef as ReactComponent };